import React, { useState, useEffect, useRef } from 'react';
import Header from '../Common_Files/Header';
import Footer from '../Common_Files/Footer';
import config from '../Common_Files/Config';
import BankSuggestionBox from '../CommonComp/BankSuggestionBox';
import { DateRangePicker } from 'rsuite';
import { format } from 'date-fns';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import axios from 'axios';
import Swal from 'sweetalert2';

const PAYMENT_MODES = ['Cash', 'Cheque', 'Online', 'Bank Transfer'];

const parseFilterDate = (value) => {
    if (!value) return null;
    const parts = String(value).split('/');
    if (parts.length !== 3) return null;
    const month = parseInt(parts[0], 10);
    const day = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);
    if (!month || !day || !year) return null;
    const date = new Date(year, month - 1, day);
    return Number.isNaN(date.getTime()) ? null : date;
};

const emptyForm = {
    expense_id: '',
    expense_date: '',
    category: '',
    amount: '',
    bank_id: '',
    payment_mode: '',
    reference_no: '',
    party_name: '',
    description: '',
};

const Expense = () => {
    const accessToken = localStorage.getItem('accessToken');
    const tableRef = useRef(null);
    const modalRef = useRef(null);
    const [searchValue, setSearchValue] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [saving, setSaving] = useState(false);
    const [modalTitle, setModalTitle] = useState('Add Expense');
    const [form, setForm] = useState(emptyForm);
    const [bankOption, setBankOption] = useState(null);

    const handleDateChange = (dates) => {
        if (dates && dates.length === 2) {
            const [start, end] = dates;
            setFromDate(format(start, 'MM/dd/yyyy'));
            setToDate(format(end, 'MM/dd/yyyy'));
        } else if (!dates) {
            setFromDate('');
            setToDate('');
        }
    };

    const openModal = () => {
        if (!modalRef.current) return;
        const existing = window.bootstrap.Modal.getInstance(modalRef.current);
        if (existing) {
            existing.show();
            return;
        }
        new window.bootstrap.Modal(modalRef.current).show();
    };

    const closeModal = () => {
        if (!modalRef.current) return;
        const bsModal = window.bootstrap.Modal.getInstance(modalRef.current);
        if (bsModal) bsModal.hide();
    };

    const resetForm = () => {
        setForm(emptyForm);
        setBankOption(null);
        setModalTitle('Add Expense');
    };

    const initializeDataTable = () => {
        if (!accessToken) {
            window.location.href = '/login';
            return;
        }
        const $table = $(tableRef.current);
        if ($.fn.DataTable.isDataTable($table)) {
            $table.off();
            $table.DataTable().destroy();
        }

        let i = 0;
        $table.DataTable({
            processing: true,
            serverSide: true,
            ajax: {
                url: `${config.api_url}/ws-expense-list`,
                type: 'POST',
                headers: { authorization: `Bearer ${accessToken}` },
                data: (d) => ({
                    ...d,
                    searchValue,
                    searchByFromdate: fromDate,
                    searchByTodate: toDate,
                }),
                dataSrc: (json) => (Array.isArray(json.data) ? json.data : []),
            },
            columns: [
                {
                    data: null,
                    render: () => ++i,
                },
                { data: 'expense_date' },
                { data: 'category' },
                { data: 'reference_no' },
                { data: 'payment_mode' },
                { data: 'bank_name' },
                {
                    data: 'amount',
                    className: 'text-end',
                },
                { data: 'description' },
                {
                    data: null,
                    orderable: false,
                    render: (data, type, row) => `
                        <a href="#" class="editbtn me-2" data-id="${row.id}" title="Edit">
                            <i class="fa fa-edit"></i>
                        </a>
                        <a href="#" class="editbtn expense-delete-btn me-2" data-id="${row.id}" title="Delete">
                            <i class="fa fa-trash"></i>
                        </a>`,
                },
            ],
            columnDefs: [{ orderable: false, targets: '_all' }],
            pageLength: 50,
            drawCallback: () => {
                i = 0;
            },
        });

        $table.on('click', '.editbtn:not(.expense-delete-btn)', function (e) {
            e.preventDefault();
            handleEditClick($(this).data('id'));
        });

        $table.on('click', '.expense-delete-btn', function (e) {
            e.preventDefault();
            handleDeleteClick($(this).data('id'));
        });
    };

    useEffect(() => {
        initializeDataTable();
        return () => {
            if (tableRef.current && $.fn.DataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).off();
                $(tableRef.current).DataTable().destroy();
            }
        };
    }, [searchValue, fromDate, toDate]);

    const handleAddClick = () => {
        resetForm();
        setForm({
            ...emptyForm,
            expense_date: format(new Date(), 'yyyy-MM-dd'),
        });
        setModalTitle('Add Expense');
        openModal();
    };

    const handleEditClick = async (id) => {
        try {
            const formData = new FormData();
            formData.append('expense_id', id);
            const response = await axios.post(`${config.api_url}/ws-get-expense-by-id`, formData, {
                headers: { authorization: `Bearer ${accessToken}` },
            });
            if (!response.data.success || !response.data.expense) {
                Swal.fire({
                    title: 'Error!',
                    text: response.data.message || 'Expense not found.',
                    icon: 'error',
                    timer: 1500,
                    showConfirmButton: false,
                });
                return;
            }
            const row = response.data.expense;
            setForm({
                expense_id: String(row.id),
                expense_date: row.expense_date_raw || '',
                category: row.category || '',
                amount: row.amount || '',
                bank_id: row.bank_id ? String(row.bank_id) : '',
                payment_mode: row.payment_mode || '',
                reference_no: row.reference_no || '',
                party_name: row.party_name || '',
                description: row.description || '',
            });
            setBankOption(
                row.bank_id
                    ? { value: Number(row.bank_id), label: row.bank_name || `Bank ${row.bank_id}` }
                    : null
            );
            setModalTitle('Edit Expense');
            openModal();
        } catch {
            Swal.fire({
                title: 'Error!',
                text: 'Failed to load expense.',
                icon: 'error',
                timer: 1500,
                showConfirmButton: false,
            });
        }
    };

    const handleDeleteClick = async (id) => {
        const result = await Swal.fire({
            title: 'Delete expense?',
            text: 'This expense will be removed.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete',
            cancelButtonText: 'Cancel',
        });
        if (!result.isConfirmed) return;
        try {
            const formData = new FormData();
            formData.append('expense_id', id);
            const response = await axios.post(`${config.api_url}/ws-delete-expense`, formData, {
                headers: { authorization: `Bearer ${accessToken}` },
            });
            if (response.data.success) {
                Swal.fire({
                    title: 'Deleted!',
                    text: 'Expense deleted successfully.',
                    icon: 'success',
                    timer: 1500,
                    showConfirmButton: false,
                }).then(() => initializeDataTable());
            } else {
                Swal.fire({
                    title: 'Error!',
                    text: response.data.message || 'Failed to delete expense.',
                    icon: 'error',
                    timer: 1500,
                    showConfirmButton: false,
                });
            }
        } catch {
            Swal.fire({
                title: 'Error!',
                text: 'Failed to delete expense.',
                icon: 'error',
                timer: 1500,
                showConfirmButton: false,
            });
        }
    };

    const handleFormChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSave = async (e) => {
        e.preventDefault();
        if (!form.category.trim()) {
            Swal.fire({
                title: 'Validation',
                text: 'Category is required.',
                icon: 'warning',
                timer: 1500,
                showConfirmButton: false,
            });
            return;
        }
        if (!form.amount || Number(form.amount) <= 0) {
            Swal.fire({
                title: 'Validation',
                text: 'Amount must be greater than zero.',
                icon: 'warning',
                timer: 1500,
                showConfirmButton: false,
            });
            return;
        }
        if (!form.expense_date) {
            Swal.fire({
                title: 'Validation',
                text: 'Expense date is required.',
                icon: 'warning',
                timer: 1500,
                showConfirmButton: false,
            });
            return;
        }

        setSaving(true);
        const formData = new FormData();
        formData.append('expense_date', form.expense_date);
        formData.append('category', form.category.trim());
        formData.append('amount', form.amount);
        formData.append('bank_id', bankOption?.value || form.bank_id || '');
        formData.append('payment_mode', form.payment_mode);
        formData.append('reference_no', form.reference_no);
        formData.append('party_name', form.party_name);
        formData.append('description', form.description);

        const isEdit = Boolean(form.expense_id);
        if (isEdit) {
            formData.append('expense_id', form.expense_id);
        }

        try {
            const response = await axios.post(
                `${config.api_url}/${isEdit ? 'ws-update-expense' : 'ws-add-expense'}`,
                formData,
                { headers: { authorization: `Bearer ${accessToken}` } }
            );
            if (response.data.success) {
                closeModal();
                Swal.fire({
                    title: 'Success!',
                    text: isEdit ? 'Expense updated successfully.' : 'Expense added successfully.',
                    icon: 'success',
                    timer: 1500,
                    showConfirmButton: false,
                }).then(() => {
                    resetForm();
                    initializeDataTable();
                });
            } else {
                Swal.fire({
                    title: 'Error!',
                    text: response.data.message || 'Failed to save expense.',
                    icon: 'error',
                    timer: 1500,
                    showConfirmButton: false,
                });
            }
        } catch {
            Swal.fire({
                title: 'Error!',
                text: 'Failed to save expense.',
                icon: 'error',
                timer: 1500,
                showConfirmButton: false,
            });
        } finally {
            setSaving(false);
        }
    };

    return (
        <div>
            <Header />
            <div className="breadcrumbs">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 col-lg-12 col-sm-12">
                            <a href="#"><i className="fa fa-home"></i></a> &gt;{' '}
                            <a href="/Dashboard">Dashboard</a> &gt;{' '}
                            <span className="last-crumb">Expense</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="main-container">
                <div className="container-fluid">
                    <div className="show-order-area dashboard account-ledger-page">
                        <div className="account-ledger-toolbar">
                            <div className="dashform">
                                <div className="topsearch-area sales-ledger-filters">
                                    <div className="row g-2 g-lg-3 align-items-end">
                                        <div className="col-12 col-md-4 col-xl-3">
                                            <label className="col-form-label">Search</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="searchValue"
                                                placeholder="Category / Ref / Bank"
                                                value={searchValue}
                                                onChange={(e) => setSearchValue(e.target.value)}
                                            />
                                        </div>
                                        <div className="col-12 col-md-5 col-xl-4">
                                            <label className="col-form-label">Date Range</label>
                                            <DateRangePicker
                                                format="dd/MM/yyyy"
                                                editable={false}
                                                cleanable
                                                placeholder="DD/MM/YYYY - DD/MM/YYYY"
                                                style={{ width: '100%' }}
                                                value={[
                                                    parseFilterDate(fromDate),
                                                    parseFilterDate(toDate),
                                                ]}
                                                onChange={handleDateChange}
                                                onClean={() => {
                                                    setFromDate('');
                                                    setToDate('');
                                                }}
                                            />
                                        </div>
                                        <div className="col-12 col-md-3 col-xl-2">
                                            <button
                                                type="button"
                                                className="btn btn-primary w-100"
                                                onClick={handleAddClick}
                                            >
                                                Add Expense
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="account-ledger-results">
                            <div className="verical-scrl-wrapper common-table account-ledger-table-scroll">
                                <table
                                    className="table table-bordered dataTable"
                                    ref={tableRef}
                                    id="expenseTable"
                                >
                                    <thead>
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>Date</th>
                                            <th>Category</th>
                                            <th>Reference</th>
                                            <th>Payment Mode</th>
                                            <th>Bank</th>
                                            <th className="text-end">Amount</th>
                                            <th>Description</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                className="modal fade"
                id="expenseModal"
                tabIndex="-1"
                aria-hidden="true"
                ref={modalRef}
            >
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <form onSubmit={handleSave}>
                            <div className="modal-header">
                                <h5 className="modal-title">{modalTitle}</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <label className="form-label">Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="expense_date"
                                            value={form.expense_date}
                                            onChange={handleFormChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">Reference Number</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="reference_no"
                                            value={form.reference_no}
                                            onChange={handleFormChange}
                                            placeholder="Enter reference number"
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">Expense Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="category"
                                            value={form.category}
                                            onChange={handleFormChange}
                                            placeholder="Enter Expense Name"
                                            required
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">Amount</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="amount"
                                            min="0.01"
                                            step="0.01"
                                            value={form.amount}
                                            onChange={handleFormChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">Payment Mode</label>
                                        <select
                                            className="form-select"
                                            name="payment_mode"
                                            value={form.payment_mode}
                                            onChange={handleFormChange}
                                        >
                                            <option value="">Select</option>
                                            {PAYMENT_MODES.map((mode) => (
                                                <option key={mode} value={mode}>
                                                    {mode}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">Bank</label>
                                        <BankSuggestionBox
                                            bank_id={form.bank_id}
                                            onBankChange={(selected) => {
                                                setBankOption(selected);
                                                setForm((prev) => ({
                                                    ...prev,
                                                    bank_id: selected?.value
                                                        ? String(selected.value)
                                                        : '',
                                                }));
                                            }}
                                        />
                                    </div>
                                  
                                    <div className="col-md-6">
                                        <label className="form-label">Party Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="party_name"
                                            value={form.party_name}
                                            onChange={handleFormChange}
                                            placeholder="Enter party name"
                                        />
                                    </div>
                                    <div className="col-12">
                                        <label className="form-label">Description</label>
                                        <textarea
                                            className="form-control"
                                            name="description"
                                            rows="3"
                                            value={form.description}
                                            onChange={handleFormChange}
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={saving}
                                >
                                    {saving ? 'Saving...' : 'Save'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Expense;
